import { useState, useEffect, useContext } from 'react';
import { API_URL } from '@/constants';
import { useNavigate } from 'react-router';
import { simpleFetch } from '@/utils/simpleFetch';
import { AuthContext, userData } from '@panamod/react-utils';

export interface Evaluacion {
    nEncuesta: number
    cDescripcion: string
    cToken: string,
    // Campos que ya trae Obten/Evaluaciones (CONFIG.SP_OBTEN_EVALUACIONES)
    // y que antes no se leían.
    nEvaluacion: number
    nEmpresa: number
    cCodigo: string
    nTipo: number
}

const useMain = () => {
    const [status, setstatus] = useState(0);
    const [loading, setloading] = useState(false);
    const [evaluaciones, setEvaluaciones] = useState<Evaluacion[]>();
    const [evaluacionInfo, setEvaluacionInfo] = useState<Evaluacion>();

    const { isLogged, userData } = useContext(AuthContext)

    const navigate = useNavigate();

    // const {
    //     bIsLogged,
    //     userInfo,
	// } = useStore();

    const handleGetEvaluaciones = async (userInfo: userData) => {
        if (userInfo?.nUsuario) {
            const response = await simpleFetch<Evaluacion[]>({
                url: `${API_URL}Obten/Evaluaciones`,
                method: 'POST'
            })

            if(!response.success){
                setstatus(3)
            }else if( response.success && response.data){
                setstatus(2);
                setEvaluaciones(response.data);
            }else {
                setstatus(3);
            }
            setloading(false);
        }
    };

    const handleClickCard = (item: Evaluacion) => {
        setEvaluacionInfo(item)

        // nTipo 2 = flujo nuevo (v2, propio, sin tocar el flujo viejo).
        // Cualquier otro valor conserva exactamente el flujo de siempre.
        if (item.nTipo === 2) {
            navigate(`evaluaciones/${item.nEvaluacion}`);
        } else {
            navigate(`encuestas/${item.cToken}`);
        }
        // setAssets()
    };

    useEffect(() => {
        isLogged === true && userData && handleGetEvaluaciones(userData);
    }, [isLogged, userData]);

    const [page, setPage] = useState(1);
    const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const notFound = status === 3;

    return {
        handleClickCard,
        evaluaciones,
        page,
        handleChange,
        status,
        loading,
        notFound,
        evaluacionInfo
    };
};

export default useMain;
